export { default as LinkCrossedAltSolidIcon } from './LinkCrossedAltSolidIcon';
